import { render, staticRenderFns } from "./classroomReport.vue?vue&type=template&id=10482c74"
import script from "./classroomReport.vue?vue&type=script&lang=js"
export * from "./classroomReport.vue?vue&type=script&lang=js"
import style0 from "./classroomReport.vue?vue&type=style&index=0&id=10482c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports